module.exports = __webpack_public_path__ + "static/media/app.c9066136.png";